import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["open", "transitioning"],
  _excluded2 = ["animateOnMount", "children"];
import { useContext } from 'react';
import styled from 'foundations-theming/utils';
import { TwoWayTransition } from '../TwoWayTransition';
import { SandboxContext } from '../../utils/SandboxContext';
import { Layer } from '../Layer/Layer';
import { PlainWrapper } from '../TwoWayTransition/TwoWayTransition';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { filterProps } from '../../../utils/filterProps';
import { SLIDEIN_MODAL_TRANSITION_TIMING } from '../../../constants/times';
import { JUPITER_LAYER } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const getTransitionProps = animateOnMount => ({
  transitionOnMount: animateOnMount
});
const transitionTime = parseInt(SLIDEIN_MODAL_TRANSITION_TIMING, 10);
export const StyledStickyFooter = styled.div.withConfig({
  displayName: "StickyFooter__StyledStickyFooter",
  componentId: "ixn3m-0"
})(({
  theme,
  sandboxed: __sandboxed,
  $cssStyles
}) => {
  return Object.assign({
    background: theme.color['fill-surface-default'],
    borderBlockStart: `${theme.borderWidth[100]} solid ${theme.color['border-core-subtle']}`,
    bottom: theme.space[0],
    left: theme.space[0],
    position: __sandboxed ? 'absolute' : 'fixed',
    right: theme.space[0],
    zIndex: JUPITER_LAYER,
    lineHeight: theme.typography['heading-300'].lineHeight
  }, $cssStyles);
});
const StickyFooterTransitionWrapper = styled(props => {
  const {
      open,
      transitioning
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(PlainWrapper, Object.assign({
    "data-component-name": "StickyFooter",
    "data-open-complete": open && !transitioning
  }, rest));
}).withConfig({
  displayName: "StickyFooter__StickyFooterTransitionWrapper",
  componentId: "ixn3m-1"
})(["& ", "{transition-property:", ";transition-duration:", "ms;transform:", ";}"], StyledStickyFooter, ({
  transitionActive
}) => transitionActive ? 'transform' : 'none', transitionTime, ({
  open
}) => `translateY(${open ? '0' : '100'}%)`);
function StickyFooterTransition(props) {
  return /*#__PURE__*/_jsx(TwoWayTransition, Object.assign({}, props, {
    duration: transitionTime,
    Wrapper: StickyFooterTransitionWrapper
  }));
}
export const StickyFooter = _ref => {
  let {
      animateOnMount = true,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  const {
    sandboxed
  } = useContext(SandboxContext);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const renderedFooter = /*#__PURE__*/_jsx(StyledStickyFooter, Object.assign({
    sandboxed: sandboxed,
    $cssStyles: cssStyles
  }, domProps, rest, {
    children: children
  }));
  return sandboxed ? renderedFooter : /*#__PURE__*/_jsx(Layer, {
    "data-layer-for": "StickyFooter",
    Transition: StickyFooterTransition,
    transitionProps: getTransitionProps(animateOnMount),
    children: renderedFooter
  });
};